var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvgate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200.66 289.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#273a57;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M387.21,56.17c-10.11,0-15.23-4.91-15.23-12.98V26.17h13.33c9.8,0,15.23,4.89,15.23,12.98v17.02h-13.33Zm3.81,162.97c-12.7,0-19.04-6.05-19.04-17.87V83.57h9.21c12.7,0,19.04,6.07,19.04,17.89v117.68h-9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M544.69,219.14c-12.7,0-19.04-6.05-19.04-17.87v-45.51c0-42.39-11.84-57.39-43.55-57.39h-27.13v120.78h-8.93c-12.41,0-18.75-6.05-18.75-17.87V83.57h58.84c45,0,67.5,21.05,67.5,63.47v72.11h-8.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M645.35,217.41c-1.16,2.89-4.91,4.34-11.55,4.34s-10.37-1.45-11.54-4.34l-60.91-133.84h17.61c9.8,0,15.86,3.81,19.04,11.54l38.07,95.77,37.5-95.77c4.32-9.52,7.79-11.54,17.87-11.54h12.13l-58.21,133.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M837.75,214.25c0,57.39-17.61,75.57-79.63,75.57h-4.61l5.2-14.71h4.32c36.62,0,46.73-13.84,46.73-60V98.64h-34.63c-26.54,0-39.8,15.58-39.8,46.73v12.11c0,31.16,12.41,46.73,36.93,46.73h19.32l-4.61,15h-14.7c-42.98,0-65.77-19.89-65.77-61.73v-12.11c0-41.88,22.84-61.73,65.77-61.73h65.48l-.02,130.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M966.66,219.14c-12.39,0-18.45-6.05-18.45-18.18v-47.59h-29.35c-26.82,0-35.2,7.21-35.2,26.54s9.52,24.23,32.59,24.23h13.57l5.18,15h-22.27c-37.21,0-55.68-12.96-55.68-39.23,0-28.84,17.89-41.25,58.55-41.25h32.04c-2.04-26.82-15.02-40.37-38.95-40.37h-28.55l-4.61-14.71h33.18c44.72,0,66.91,19.63,66.91,58.55v77.02h-8.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1060.98,219.14c-42.7,0-54.52-12.11-54.52-48.45V98.36h-23.07l5.48-14.71h17.55V45h8.07c12.98,0,19.34,6.05,19.34,17.87v20.77h37.79l-5.48,14.71h-32.36v76.14c0,19.91,7.21,29.71,21.62,29.71h14.71l5.2,15-14.33-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1199.43,158.57h-76.43l4.89-15.57h48.47c0-31.16-9.23-46.73-33.46-46.73h-3.81c-23.36,0-33.46,19.91-33.46,49.04v17.89c0,23.07,16.45,40.95,39.52,40.95h37.5l5.48,15h-42.62c-42.98,0-68.66-21.05-68.66-61.73v-12.11c0-38.36,23.95-63.18,62.3-63.18h3.81c38.38,0,57.7,20.2,57.7,60.31,.11,5.41-.3,10.81-1.22,16.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M127.27,266.96V137.4c-.09-7.36,5.79-13.4,13.15-13.5,.06,0,.11,0,.17,0h.42V253.67c0,7.36-5.96,13.33-13.32,13.33-.06,0-.13,0-.19,0l-.23-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M205.89,37.01c-.01,15.08-12.24,27.29-27.32,27.28-15.08-.01-27.29-12.24-27.28-27.32,.01-15.08,12.24-27.29,27.32-27.28,15.07,0,27.28,12.21,27.28,27.28v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M149.15,.84c-4.98-.55-9.99-.83-15-.84C60.04,.02-.02,60.11,0,134.22c.02,64.94,46.54,120.55,110.46,132.03v-58.36c-41.06-12.65-64.1-56.19-51.46-97.25,10.04-32.62,40.17-54.88,74.3-54.9,2.06,0,4.13,.1,6.17,.27-14.65-6.1-21.58-22.91-15.48-37.56,4.25-10.2,13.97-17.06,25-17.65l.15,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M251.35,76.79c0,12.34-10.01,22.35-22.35,22.35s-22.35-10.01-22.35-22.35c0-12.33,9.99-22.34,22.33-22.35,12.34-.01,22.36,9.99,22.37,22.33v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M267.03,124.48c0,9.46-7.67,17.13-17.13,17.13s-17.13-7.67-17.13-17.13,7.67-17.13,17.13-17.13,17.13,7.67,17.13,17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M262.62,165.55c0,6.71-5.44,12.14-12.14,12.14-6.71,0-12.14-5.44-12.14-12.14,0-6.71,5.44-12.14,12.14-12.14h.02c6.7,.01,12.13,5.44,12.13,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M248.8,198.52c-.01,4.43-3.61,8.01-8.03,7.99-4.43-.01-8.01-3.61-8-8.03,.01-4.42,3.6-8,8.01-8,4.43,.01,8.01,3.6,8.01,8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M233.78,219.35c0,3.15-2.56,5.71-5.71,5.71s-5.71-2.56-5.71-5.71,2.56-5.71,5.71-5.71,5.71,2.56,5.71,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M216.44,236.35c.01,1.98-1.58,3.59-3.56,3.6-1.98,.01-3.59-1.58-3.6-3.56-.01-1.98,1.58-3.59,3.56-3.6h.02c1.97,0,3.57,1.59,3.58,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M201.38,247.66c0,1.34-1.08,2.42-2.42,2.42-1.34,0-2.42-1.08-2.42-2.42,0-1.33,1.07-2.41,2.4-2.42,1.34-.01,2.43,1.06,2.44,2.4v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M183.87,256.85c.01,.66-.52,1.21-1.18,1.22-.66,.01-1.21-.52-1.22-1.18-.01-.66,.52-1.21,1.18-1.22,.01,0,.03,0,.04,0,.65,.01,1.17,.53,1.18,1.18Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvgate);
export default __webpack_public_path__ + "static/media/invgate.b6ef5a116d573748d51eabdd8109f8fd.svg";
export { ForwardRef as ReactComponent };